export const userSkipsExtraSelection = () => {
  return {
    type: 'User skips extras selection',
  };
};

export const userContinuesWithExtraSelection = (
  selectedExtras = [],
  breeds,
) => ({
  type: 'User continues with extras selection',
  data: {
    extras_count: selectedExtras.length,
    extras_selected: selectedExtras.map(extra => extra.sku),
    breeds: breeds,
  },
});
